<form name="editLabel" novalidate>
    <sq-modal [title]="'msg#editLabel.title'" [buttons]="buttons" [isProcessingState]="isProcessing">
        <div class="mb-3 sq-form-group">
            <div class="alert alert-warning" role="alert">
                {{'msg#editLabel.alertText' | sqMessage}}
            </div>
            <div *ngIf="model.properties.allowManagePublicLabels || !model.properties.public " class="alert alert-info" role="alert">
                {{'msg#editLabel.infoText' | sqMessage}}
            </div>
            <section class="d-flex gap-3 mb-3">
                <div *ngFor="let item of model.properties.radioButtons" class="form-check">
                    <input type="radio" class="form-check-input" id="{{item.id}}" name="nature" value="{{item.value}}"
                        [checked]="item.checked" [disabled]="item.disabled" (click)="updateLabelsNature(item.value)" [ngClass]="{'disabled': item.disabled, 'clickable': !item.disabled}">
                    <label role="button" class="form-check-label" for="{{item.id}}">{{ item.name | sqMessage }}</label>
                </div>
            </section>

            <section *ngIf="record">
                <label class="form-label fw-bold" for="label">{{'msg#labels.labels' | sqMessage}}</label>
                <sq-labels-autocomplete
                    (labelsUpdate)="onLabelsChanged($event)"
                    [public]="model.properties.public"
                    [disableAutocomplete]="model.properties.disableAutocomplete"
                    [allowNewLabels]="model.properties.allowNewLabels"
                    [allowManagePublicLabels]="model.properties.allowManagePublicLabels"
                    [initLabels]="initialLabels">
                </sq-labels-autocomplete>
            </section>

            <section *ngIf="!record">
                <label class="form-label fw-bold" for="label">{{'msg#editLabel.labelsToBeAdded' | sqMessage}}</label>
                <sq-labels-autocomplete
                    (labelsUpdate)="onLabelsToBeAddedChanged($event)"
                    [public]="model.properties.public"
                    [disableAutocomplete]="model.properties.disableAutocomplete"
                    [allowNewLabels]="model.properties.allowNewLabels"
                    [allowManagePublicLabels]="model.properties.allowManagePublicLabels">
                </sq-labels-autocomplete>
                <label class="form-label fw-bold" for="label">{{'msg#editLabel.labelsToBeRemoved' | sqMessage}}</label>
                <sq-labels-autocomplete
                    (labelsUpdate)="onLabelsToBeRemovedChanged($event)"
                    [public]="model.properties.public"
                    [disableAutocomplete]="model.properties.disableAutocomplete"
                    [allowNewLabels]="model.properties.allowNewLabels"
                    [allowManagePublicLabels]="model.properties.allowManagePublicLabels">
                </sq-labels-autocomplete>
            </section>

        </div>
    </sq-modal>
</form>
